"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SDK = void 0;
const authAPI_1 = require("./authAPI");
const brochureAPI_1 = require("./brochureAPI");
const videoAPI_1 = require("./videoAPI");
const irMaterialAPI_1 = require("./irMaterialAPI");
const pageAPI_1 = require("./pageAPI");
const fileAPI_1 = require("./fileAPI");
__exportStar(require("./types"), exports);
__exportStar(require("./authAPI"), exports);
__exportStar(require("./noticeAPI"), exports);
__exportStar(require("./newsAPI"), exports);
__exportStar(require("./press-releaseAPI"), exports);
__exportStar(require("./s3API"), exports);
__exportStar(require("./pageViewAPI"), exports);
__exportStar(require("./shareholderMeetingAPI"), exports);
__exportStar(require("./disclosureAPI"), exports);
__exportStar(require("./videoAPI"), exports);
__exportStar(require("./brochureAPI"), exports);
__exportStar(require("./irMaterialAPI"), exports);
__exportStar(require("./pageAPI"), exports);
__exportStar(require("./fileAPI"), exports);
class SDK {
    constructor(baseURL, headers = {}) {
        this.baseURL = baseURL;
        this.headers = headers;
        this.auth = new authAPI_1.AuthAPI(baseURL);
        this.brochure = new brochureAPI_1.BrochureAPI(baseURL);
        this.video = new videoAPI_1.VideoAPI(baseURL);
        this.irMaterial = new irMaterialAPI_1.IRMaterialAPI(baseURL);
        this.page = new pageAPI_1.PageAPI(baseURL);
        this.file = new fileAPI_1.FileAPI(baseURL);
    }
}
exports.SDK = SDK;
